export default __webpack_public_path__ + "static/media/FleetMonitoring.c475ebd7.jpg";